module.exports = __webpack_public_path__ + "img/testimonials_default.0b02a4b3.png";